import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .TransferCommonDetails {
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
    padding: rem(25px 60px 10px 30px);
    margin-bottom: rem(20px);
    position: relative;
    @include respond-to(sm) {
      padding: rem(20px 15px 15px);
    }
    ul {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      gap: 12px;
      li {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
        padding: 0 5px;
        font-size: 15px;

        span {
          &:first-child {
            font-size: 13px;
            display: block;
            margin-bottom: 5px;
          }
        }

        :global(.StatusCell) {
          font-size: 13px;
        }

        :global(.DateCell) {
          span {
            font-size: 15px;
          }
        }
      }
    }

    &__change-status-wrapper {
      margin-bottom: 8px;

      .ChangeStatusButton {
        margin-top: 8px;
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .TransferCommonDetails {
      background-color: ${colors.white.hex};
      ul {
        li {
          span {
            &:first-child {
              color: ${colors.gray.hex};
            }
          }

          :global(.DateCell) {
            span {
              &:first-child {
                color: ${colors.black.hex};
              }
            }
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
